export default __webpack_public_path__ + "static/partner3-a5cca73efe4545918365c7377bdf0c7e.png";